<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    :stroke="color"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    width="24"
    height="24"
  >
    <polyline points="20 6 9 17 4 12" />
  </svg>
</template>

<script>
export default {
  name: "CheckedMarkIcon",
  props: {
    color: {
      type: String,
      default: "#67C23A", // yashil default rang
    },
  },
};
</script>

<style scoped></style>
